import { EquityBridgeColumnRole } from '@app/shared/models/contracts/enums/shared-enums';
import { EquityBridgeColumnDto } from '@app/shared/models/contracts/project-dto';
import { l } from '@locale/setupI18n';

export enum ShiftDirection {
  Left,
  Right,
}

export const isDefaultColumn = (column: EquityBridgeColumnDto): boolean =>
  column.role === EquityBridgeColumnRole.Investment ||
  column.role === EquityBridgeColumnRole.Valuation;

export const roleLabel = (column: EquityBridgeColumnDto): string => {
  switch (column.role) {
    case EquityBridgeColumnRole.Investment:
      return l('_Original');
    case EquityBridgeColumnRole.Valuation:
      return l('_Valuation');
    default:
      return column.dateMemo;
  }
};
